import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 3,
        },
      }}
    >
      <div
        className="md:w-[360px] w-[300px]"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "24px",
          backgroundColor: "#ffffff",
          textAlign: "center",
        }}
      >
        <div style={{ height: "32px" }} />
        {/* 메세지만 있을경우 BOLD로 대체 */}
        {!title && message ? (
          <>
            <div className="f20_111827_W600">{message}</div>
          </>
        ) : (
          <>
            <div className="f20_111827_W600">{title}</div>
            <div className="f14_4B5563_W500">{message}</div>
          </>
        )}
        <div style={{ height: "42px" }} />
        <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
          <div
            onClick={() => onClose()}
            className="f16_2E4A24_W500"
            style={{
              flex: "1",
              padding: "13px 0px",
              border: "1px solid #2E4A24",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            아니오
          </div>
          <div
            onClick={() => onConfirm()}
            className="f16_FFFFFF_W500"
            style={{
              flex: "1",
              padding: "13px 0px",
              backgroundColor: "#2E4A24",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            네
          </div>
        </div>
      </div>
    </Dialog>
  );
}
